export const groupConstants = {
  GETALL_GROUPS_REQUEST: 'GETALL_GROUPS_REQUEST',
  GETALL_GROUPS_SUCCESS: 'GETALL_GROUPS_SUCCESS',
}